import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Instagram, Facebook, Mail } from 'lucide-react';
import PrivacyBadge from './PrivacyBadge';
import client from '../api/client';

export default function Footer() {
  const [cfg, setCfg] = useState({
    legal_relationship_text: 'Your Wedding Friends is operated by Half Genius Labs LLC.',
    legal_company_name: 'Half Genius Labs LLC',
    brand_name: 'Your Wedding Friends',
    entity_state: 'Wyoming',
    entity_type: 'Limited Liability Company',
    communications_attribution: 'Powered by Quo',
    copyright_year: new Date().getFullYear(),
  });
  useEffect(() => {
    client.get('/legal/config').then(({ data }) => setCfg((c) => ({ ...c, ...data }))).catch(() => {});
  }, []);
  return (
    <footer className="bg-[#2A1F1B] text-[#F4E4DA] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-[#F4D6CE] flex items-center justify-center">
                <Heart className="w-4 h-4 text-[#7B2C3B] fill-[#7B2C3B]" />
              </div>
              <span className="font-serif text-xl font-semibold">
                Yourwedding<span className="italic text-[#F4D6CE]">friends</span>
              </span>
            </div>
            <p className="text-sm text-[#E0CFC2] max-w-md leading-relaxed">
              The calmest, smartest, kindest way to plan your wedding. Built by couples who actually got married — for couples who want to actually enjoy it.
            </p>
            <div className="mt-5">
              <PrivacyBadge variant="footer" />
            </div>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full border border-[#5A4439] flex items-center justify-center hover:bg-[#5A4439] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full border border-[#5A4439] flex items-center justify-center hover:bg-[#5A4439] transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="mailto:hello@yourweddingfriends.com" aria-label="Email" className="w-9 h-9 rounded-full border border-[#5A4439] flex items-center justify-center hover:bg-[#5A4439] transition-colors">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4 text-[#FBF7F2]">Product</h4>
            <ul className="space-y-2 text-sm text-[#E0CFC2]">
              <li><Link to="/#features" className="hover:text-[#F4D6CE]">Features</Link></li>
              <li><Link to="/#pricing" className="hover:text-[#F4D6CE]">Pricing</Link></li>
              <li><Link to="/dashboard" className="hover:text-[#F4D6CE]">Live demo</Link></li>
              <li><Link to="/#faq" className="hover:text-[#F4D6CE]">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4 text-[#FBF7F2]">Company</h4>
            <ul className="space-y-2 text-sm text-[#E0CFC2]">
              <li><Link to="/our-story" className="hover:text-[#F4D6CE]">Our story</Link></li>
              <li><Link to="/real-weddings" className="hover:text-[#F4D6CE]">Real weddings</Link></li>
              <li><Link to="/partners" className="hover:text-[#F4D6CE]">Become a partner</Link></li>
              <li><Link to="/contact" className="hover:text-[#F4D6CE]">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#5A4439]">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-3">
            <div className="text-xs text-[#B9A599] space-y-1 max-w-xl">
              <p>© {cfg.copyright_year} {cfg.brand_name}. All rights reserved.</p>
              <p data-testid="footer-legal-identity">
                {cfg.brand_name} is operated by <strong className="text-[#F4D6CE]">{cfg.legal_company_name}</strong>, a {cfg.entity_state} {cfg.entity_type}.
              </p>
              <p className="text-[10px] text-[#8E7B70]">{cfg.communications_attribution}</p>
            </div>
            <div className="flex items-center gap-5 text-xs text-[#B9A599] flex-wrap">
              <Link to="/legal" className="hover:text-[#F4D6CE]">Legal center</Link>
              <Link to="/privacy" className="hover:text-[#F4D6CE]">Privacy</Link>
              <Link to="/terms" className="hover:text-[#F4D6CE]">Terms</Link>
              <Link to="/sms-terms" className="hover:text-[#F4D6CE]">SMS terms</Link>
              <Link to="/cookies" className="hover:text-[#F4D6CE]">Cookies</Link>
              <Link to="/accessibility" className="hover:text-[#F4D6CE]">Accessibility</Link>
              <Link to="/privacy-request" data-testid="footer-privacy-request" className="hover:text-[#F4D6CE]">Privacy request</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
